export default "__VITE_ASSET__oR7AYLUy__"